import { ModeOfPayment } from '@wot/typings';
import xhr from '../utils/fetch';

export interface PPlanReqBody {
  userId: string;
  tutorId: string;
  basePlanId?: string;
  categoryType: string;
  category: {
    name: string[];
    grade: string;
    board: string;
  };
  purchasedSessions: number;
  totalSessions: number;
  costPerSession: number;
  status: string;
  discount: number;
  totalCost: number;
  noOfCancelsByStudent: { total: number; occured: number };
  noOfCancelsByTutor: { total: number; occured: number };
  noOfReschedulesByStudent: { total: number; occured: number };
  noOfReschedulesByTutor: { total: number; occured: number };
  paymentDetails?: {
    modeOfPayment: ModeOfPayment;
    transactionId?: string;
    status: string;
  };
}

const get = async (userId: string) => {
  return await xhr({
    url: `/u/${userId}/plans`,
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const getById = async (userId: string, planId: string) => {
  return await xhr({
    url: `/u/${userId}/plans/${planId}`,
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const add = async (userId: string, plan: PPlanReqBody) => {
  return await xhr({
    url: `/u/${userId}/plans`,
    method: 'POST',
    body: plan
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const addPlanDraft = async (userId: string, plan: PPlanReqBody) => {
  return await xhr({
    url: `/u/${userId}/plan-draft`,
    method: 'POST',
    body: plan
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const changeTutorRequest = async (planId: string, reason: string) => {
  return await xhr({
    url: `/u/plans/change-tutor-request`,
    method: 'POST',
    body: { planId, reason }
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const deleteChangeTutorRequest = async (planId: string) => {
  return await xhr({
    url: `/u/plans/change-tutor-request`,
    method: 'PUT',
    body: { planId }
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const addSessions = async (userId: string, planId: string, sessions: any[]) => {
  return await xhr({
    url: `/u/${userId}/plans/${planId}/add-sessions`,
    method: 'PUT',
    body: sessions
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const cancelPlan = async (planId: string) => {
  return await xhr({
    url: `/u/plans/${planId}/cancel`,
    method: 'POST'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const getPlanAttendance = async (userId: string, planId: string) => {
  return await xhr({
    url: `/u/${userId}/plans/${planId}/attendance`,
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const getPlansAttendance = async (userId: string) => {
  return await xhr({
    url: `/u/${userId}/attendance`,
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

export const plansApi = {
  get,
  getById,
  add,
  addPlanDraft,
  changeTutorRequest,
  cancelPlan,
  deleteChangeTutorRequest,
  addSessions,
  getPlansAttendance,
  getPlanAttendance
};
